(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["podbase-poster-prototype"] && !Shopify.designMode) return;
  try {
    function initPosterPrototype() {
    document.querySelectorAll('[data-podbase-poster-prototype]').forEach((root) => {
      if (root.dataset.posterReady) return;
      root.dataset.posterReady = 'true';
      const price = root.querySelector('[data-poster-price]');
      const gallery = root.closest('[data-product-grid-content]')?.querySelector('media-gallery');
      const id = root.querySelector('[data-poster-variant-id]');
      const submit = root.querySelector('[data-poster-submit]');
      function selectImage(radio) {
        if (!gallery) return;
        gallery.querySelectorAll(`[data-media-id="${root.dataset.primaryMediaId}"] img`).forEach((image) => {
          image.removeAttribute('srcset');
          image.src = image.closest('.dialog-zoomed-gallery') ? radio.dataset.imageFull : radio.dataset.image;
          image.alt = radio.dataset.imageAlt;
          image.dataset.maxResolution = radio.dataset.imageFull;
        });
        gallery.querySelectorAll('.dialog-thumbnails-list__thumbnail:first-child img, .slideshow-controls__thumbnail:first-child img').forEach((image) => {
          image.removeAttribute('srcset');
          image.src = radio.dataset.imageThumb;
          image.alt = radio.dataset.imageAlt;
        });
      }
      const initial = root.querySelector('input[type=radio][data-price]:checked');
      if (initial) selectImage(initial);
      root.querySelectorAll('input[type=radio][data-price]').forEach((radio) => {
        radio.addEventListener('change', () => {
          if (!radio.checked || radio.disabled) return;
          id.value = radio.value;
          price.textContent = radio.dataset.price;
          selectImage(radio);
          submit.disabled = false;
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPosterPrototype);
  } else {
    initPosterPrototype();
  }
  } catch(e) { console.error(e); }
})();

})();
